import React from 'react';

import {
  SearchResult,
} from '../../../components';

import StaffTeaser from './Teaser';
import StaffFull from './Full';

const Staff = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<StaffTeaser entity={entity} {...props} />);
    case 'full':
    default:
      return (<StaffFull entity={entity} {...props} />);
  }
};

export default Staff;
